export default "__VITE_ASSET__VltP7Upn__"